// extracted by css-extract-rspack-plugin
export default {"titleColumn":"_38699b79","valueColumn":"_3e4c7412"};